import React from 'react'
import { ErrorMessage, FormikProvider, useFormik } from 'formik';
import { Button, Col, Form, Row } from 'react-bootstrap';
import * as Yup from "yup";
import { config } from '../Components/CommonUtilities/CommonUrl/CommonUrls';
import Sweetalert from '../Components/CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import { CommonAxiosPost } from '../Components/CommonUtilities/CommonAxios/CommonAxios';
import { useNavigate } from 'react-router-dom';
import { ERROR_MSG, PWD_REG } from '../Components/CommonUtilities/Validations/RegularExpAndVar';

export default function ChangePassword() {
  const userValidationSchema = Yup.object().shape({
    oldPassword: Yup.string().required(ERROR_MSG),
    newPassword: Yup.string().required(ERROR_MSG).matches(PWD_REG,
      "Password must contain at least 8 characters, one uppercase, one number and one special case character").min(8).max(20),
    rePassword: Yup.string().required(ERROR_MSG).oneOf([Yup.ref("newPassword"), null], "Password doesn't match."),
  });
  let navigate = useNavigate()
  const Formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      oldPassword: "",
      newPassword: "",
      rePassword: ""
    }
    ,
    onSubmit: (values) => {
      let url = config.url.DSC_URL + "change-password"
      CommonAxiosPost(url, values).then((res) => {
        if (res?.data?.status === true) {
          Sweetalert('successfully Changed', 'success')
          navigate(-1)
        }
        else {
          Sweetalert(res?.data?.sdesc ? res?.data?.sdesc : 'Unauthorized Access ! Please Login', "error")
        }

      })
    },
    validationSchema: userValidationSchema,
  })
  return (
    <React.Fragment>

      <div className="heading-main mt-5">
        <h3 className="main-title">Change Password</h3>
      </div>
      <FormikProvider value={Formik}>
        <Form className="form-section" onSubmit={Formik.handleSubmit} onChange={Formik.handleChange} >
          <div className="personal-row pb-3 ">
            <Row className="row">
              <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12}>
                <Form.Group controlId="oldPassword" >
                  <Form.Label className="input-lable mb-2">Old Password</Form.Label>
                  <input
                    type="password"
                    name="oldPassword"
                    maxLength='30'
                    className="input-field form-control"
                    placeholder="Enter Old Password"
                    onChange={(e) => Formik.setFieldValue('oldPassword', e.target.value)}
                  />
                </Form.Group>
                <ErrorMessage
                  name="oldPassword"
                  component="div"
                  className="text-error"
                />
              </Col>
              <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12}>
                <Form.Group controlId="newPassword" >
                  <Form.Label className="input-lable mb-2">New Password</Form.Label>
                  <input
                    type="password"
                    maxLength='30'
                    name="newPassword"
                    className="input-field form-control"
                    placeholder="Enter New Password"
                    onChange={(e) => Formik.setFieldValue('newPassword', e.target.value)}
                  />
                </Form.Group>
                <ErrorMessage
                  name="newPassword"
                  component="div"
                  className="text-error"

                />
              </Col>
              <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12}>
                <Form.Group controlId="rePassword" >
                  <Form.Label className="input-lable mb-2">Re-Enter Password</Form.Label>
                  <input
                    type="password"
                    maxLength='30'
                    name="rePassword"
                    className="input-field form-control"
                    placeholder="Re-Enter Password"
                    onChange={(e) => Formik.setFieldValue('rePassword', e.target.value)}
                  />
                </Form.Group>
                <ErrorMessage
                  name="rePassword"
                  component="div"
                  className="text-error"
                />
              </Col>
              <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3} className='pt-2' >
                <Button variant="success" type="submit" className="submit-btn btn-success float-end mt-3">
                  Submit
                </Button>
              </Col>
            </Row>
          </div>


        </Form>
      </FormikProvider>

    </React.Fragment>
  )
}
